import React, {memo} from "react";
import {ScreenState} from "@/app/features/chats/slice";
import styles from "./styles.module.scss";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";
import LazyAssets from "@/app/utils/assets_widget";
import IconButton from "@/app/components/icon_button";
import LazyImage from "@/app/components/lazy_image";
import classNames from "classnames";
import {TextBold16, TextMedium14, TextMedium16, ThirtyText} from "@/app/components/texts";
import Input from "@/app/components/input";
import MessageWidget from "@/app/features/chats/components/message_block/widget";
import useChat from "@/app/features/chats/chat_page/slice";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import Space from "@/app/components/space";
import BottomSheet from "@/app/components/bottom_sheet/widget";
import AddMemberPage from "@/app/components/add_member_page/widget";

interface Props {
  state: ScreenState;
  goBack: () => void
  sendMessage: (message: string) => void,
  addUserToChat: (userId: number | undefined) => void
}


const ChatPage: React.FC<Props> = ({state, goBack, sendMessage, addUserToChat}) => {
  const {message, showAddMember, updateMessage, toggleShowAddMember} = useChat();

  if (!state.selectedChat) return null;

  return (
    <div className={styles.chatPage}>
      <div className={styles.header}>
        <IconButton icon={<LazyAssets.Back/>} onClick={goBack} className={styles.back}/>
        <div className={styles.logosAndNames}>
          <div className={styles.avatars}>
            {state.selectedChat.participants.map((user, index) => {
              return user.imageLink !== null ? <LazyImage url={user.imageLink} alt={user.username}
                                                          key={index}
                                                          className={classNames(styles.avatar, styles[`z${state.selectedChat?.participants.length ?? 0 - index}`]
                                                          )}/> :
                <div
                  className={classNames(styles.avatar, styles.empty, styles[`z${state.selectedChat?.participants.length ?? 0 - index}`]
                  )} key={index}>
                  <TextMedium14 text={user?.username?.charAt(0) ?? "U"}/>
                </div>
            })}
          </div>
          <TextBold16 text={state.selectedChat.participants.map((user, index) => user.username).join(', ')}
                      className={styles.names}/>
        </div>
        <IconButton icon={<LazyAssets.Add/>} onClick={toggleShowAddMember}/>
      </div>
      {state.messages !== undefined && state.messages.length === 0 && <div className={styles.emptyPage}>
          <TextMedium16 text={t(s.noMessages)}/>
      </div>}
      {state.messages !== undefined && state.messages.length > 0 &&
          <div className={styles.messages}>
              <Space.H16/>{state.messages.map(msg => <MessageWidget key={msg.id} message={msg}
                                                                    currentUserId={state.user?.user?.id}/>)}<Space.H16/>
          </div>}
      {state.messages === undefined && <CircularProgressIndicator isGreen/>}
      <Input isTextArea value={message} className={styles.inputOnPage} onChange={updateMessage}
             buttonInInput={<IconButton icon={message.length > 0 ? <LazyAssets.SendActive/> : <LazyAssets.Send/>}
                                        onClick={message.length > 0 ? () => {
                                          updateMessage("");
                                          sendMessage(message);
                                        } : undefined} className={styles.buttonInInput}/>}
             hint={t(s.typeYourMessage)} isWhite/>
      {showAddMember && <BottomSheet open={showAddMember} onClose={toggleShowAddMember}>
          <AddMemberPage onSelect={(openId) => {
            addUserToChat(openId);
            toggleShowAddMember();
          }}/>
      </BottomSheet>}
    </div>
  );
};

export default memo(ChatPage);
